const productMain = {
	
	ui: {},

	init: function() {
		this.bindUI();
		this.bindEvents();

		this.ui.$thumbnails.eq(0).click();
		if(window.location.hash){
			var code = window.location.hash.replace("#","");
			this.ui.$thumbnails.filter("[data-code="+code+"]").eq(0).click();
		}
	},

	bindUI: function() {
		this.ui.$productMain = $('.js-productMain');
		this.ui.$thumbnails = this.ui.$productMain.find(".js-productMain-thumbnail");
		this.ui.$thumbnailsHover = this.ui.$productMain.find(".js-productMain-thumbnail-hover");
		this.ui.$full = this.ui.$productMain.find(".js-productMain-full");
		this.ui.$fullBg = this.ui.$productMain.find(".js-productMain-full-bg");
		this.ui.$preview = this.ui.$productMain.find(".js-productMain-preview");
	},

	bindEvents: function() {
		this.ui.$thumbnails.on('click', this.changePreview.bind(this));
		this.ui.$thumbnailsHover.on('mouseenter', this.enterPreview.bind(this));
		this.ui.$thumbnailsHover.on('mouseleave', this.leavePreview.bind(this));
	},

	enterPreview: function(e) {
		e.stopPropagation();
		var $this = $(e.currentTarget);
		console.log($this.attr("data-src-preview"));
		this.ui.$preview.attr("src", $this.attr("data-src-preview"));
	},
	leavePreview: function(e) {
		this.ui.$preview.attr("src", this.ui.$preview.attr("data-src"));
	},
	changePreview: function(e) {
		e.preventDefault();
		var $this = $(e.currentTarget);
		this.ui.$thumbnails.removeClass("active");
		$this.addClass("active");
		this.ui.$preview.attr("src", $this.attr("data-src-preview"));
		this.ui.$full.attr("src", $this.attr("data-src-full"));
		this.ui.$fullBg.css("background-image", "url("+$this.attr("data-src-full")+")");
	}
};

module.exports = productMain;